module.exports = __webpack_public_path__ + "img/bluesky3100_08.6af47006.jpg";